interface GuestProgressIndicatorProps {
  filledCount: number;
  totalCount: number;
}

const GuestProgressIndicator = ({
  filledCount,
  totalCount,
}: GuestProgressIndicatorProps) => {
  const percentage = totalCount > 0 ? (filledCount / totalCount) * 100 : 0;
  const isComplete = filledCount >= totalCount && totalCount > 0;

  return (
    <div className="mb-4 rounded-lg border border-backgroundGray bg-backgroundLightGray p-4">
      <div className="flex items-center justify-between">
        <span className="font-arimo text-sm font-medium text-primaryGray">
          Guest Progress:{' '}
          <span
            className={
              isComplete ? 'text-accentGreenShade' : 'text-secondaryBlue'
            }
            data-testid="guest-progress-count"
          >
            {filledCount} of {totalCount} assigned
          </span>
        </span>
        {isComplete && (
          <span className="font-arimo text-sm font-medium text-accentGreenShade">
            Complete
          </span>
        )}
      </div>
      <div
        className="mt-2 h-2 w-full overflow-hidden rounded-full bg-backgroundGray"
        role="progressbar"
        aria-valuenow={filledCount}
        aria-valuemin={0}
        aria-valuemax={totalCount}
        aria-label={`${filledCount} of ${totalCount} guests assigned`}
      >
        <div
          className={`h-full rounded-full transition-all duration-300 ${
            isComplete ? 'bg-accentGreen' : 'bg-secondaryBlue'
          }`}
          style={{ width: `${percentage}%` }}
          data-testid="guest-progress-bar"
        />
      </div>
    </div>
  );
};

export default GuestProgressIndicator;
